<header class="header-filter">
  <h5 class="title">Filtrar</h5>

  <button class="btn btn-primary btn-sm"
    type="button"
    [disabled]="disabled"
    (click)="clear.emit()">
    <i class="fas fa-undo"></i>
    Limpiar filtro
  </button>
</header>

<ng-content></ng-content>
